import { PrimaryButton } from '@grnhse/seedling/lib/birch/components/buttons';
import React from 'react';
import { useFormContext } from '@grnhse/seedling/lib/birch/components/forms/form';
import { scrollToError } from '../../../billing/modals/shared/utils';
import { FieldValues } from 'react-hook-form/dist/types/fields';

type NestedFormSubmitButtonProps = {
  buttonText: string;
  handleSubmit: (data: FieldValues) => Promise<void>;
  disabled?: boolean;
};

export const NestedFormSubmitButton = ({
  buttonText,
  handleSubmit,
  disabled = false,
}: NestedFormSubmitButtonProps) => {
  const [submitting, setSubmitting] = React.useState(false);
  const {
    getValues,
    trigger,
    formState: { errors },
  } = useFormContext();

  const onClick = async () => {
    setSubmitting(true);
    try {
      const isValid = await trigger(undefined, { shouldFocus: true });
      if (!isValid) {
        if (errors) {
          scrollToError();
        }
        return;
      }
      await handleSubmit(getValues());
    } finally {
      // Without this a throwing handleSubmit leaves the button spinning forever
      setSubmitting(false);
    }
  };

  return (
    <PrimaryButton
      loading={submitting}
      disabled={disabled || submitting}
      onClick={onClick}
    >
      {buttonText}
    </PrimaryButton>
  );
};
